import { render } from "./Signals.vue?vue&type=template&id=477ab0d6&scoped=true&ts=true"
import script from "./Signals.vue?vue&type=script&lang=ts"
export * from "./Signals.vue?vue&type=script&lang=ts"

import "./Signals.vue?vue&type=style&index=0&id=477ab0d6&scoped=true&lang=css"

import exportComponent from "/Users/rickvanwell/Work/Signals/webui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477ab0d6"]])

export default __exports__